import angular from 'angular';
import angularCreditCards from 'angular-credit-cards';
import { VerifyCreditCardConfig } from './credit-card.config';
import { VerifyCreditCardComponent } from './credit-card.component';
import { VerifyCreditCardComponent as UdsVerifyCreditCardComponent } from '../new-design/credit-card/credit-card.component';
import { StripModule } from './stripe.service';
import { StepPageModule } from '../../common/directives';
import { CardModule } from '../../core';
import { TermsOfUseModule } from '../terms-of-use';

export const VerifyCreditCardModule = angular
  .module('app.verify.credit-card', [
    angularCreditCards,
    CardModule.name,
    StepPageModule.name,
    StripModule.name,
    TermsOfUseModule.name,
  ])
  .config(VerifyCreditCardConfig)
  .component('updVerifyCreditCard', VerifyCreditCardComponent)
  .component('udsVerifyCreditCard', UdsVerifyCreditCardComponent);
